import Customer from "./customer";
import Job from "./job";
import OnSiteContact from "./on_site_contact";
import CodeTruck from "./code_truck";
import CodeProduct from "./code_product";
import JobProduct from "./job_product";
import JobFile from "./job_file";
import CodeFileType from "./code_file_type";
import CodeArea from "./code_area";
import JobNote from "./job_note";
import JobTask from "./job_task";
import TruckSize from "./truck_size";
import CodeJobTaskType from "./code_job_task_type";
import CodeTimeOfDay from "./code_time_of_day";
import PreStartCheckList from "./pre_start_check_list.js";

import {default as PermissionSchema} from "../../vue-ocom/grouppermissions/schema/index.js";

export default {
  Customer,
  Job,
  OnSiteContact,
  CodeTruck,
  CodeProduct,
  JobProduct,
  JobFile,
  CodeFileType,
  CodeArea,
  JobNote,
  JobTask,
  TruckSize,
  CodeJobTaskType,
  CodeTimeOfDay,
  PreStartCheckList,

  ...PermissionSchema /* For Schema */,
};
